import { render, staticRenderFns } from "./NotificationWithDropdown.vue?vue&type=template&id=cc42e9e8&scoped=true&"
import script from "./NotificationWithDropdown.vue?vue&type=script&lang=js&"
export * from "./NotificationWithDropdown.vue?vue&type=script&lang=js&"
import style0 from "./NotificationWithDropdown.vue?vue&type=style&index=0&id=cc42e9e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc42e9e8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VList,VListItem,VListItemContent,VListItemSubtitle,VListItemTitle,VMenu,VTooltip})
